import { Tooltip } from '@mui/material';
import { Folder as FolderIcon } from '@mui/icons-material';
import { StyledChip } from './SharedStyles';

const truncateFolderPathFromLeft = (path: string, maxLength = 25): string => {
  if (path.length <= maxLength) return path;
  return '...' + path.slice(-(maxLength - 3));
};

export const FolderPathsDetail = ({
  folderPaths,
  folderIds,
  includeHomeFolderAssets,
}: {
  folderPaths?: string[];
  folderIds?: string[];
  includeHomeFolderAssets?: boolean;
}) => {
  if (!folderPaths && !folderIds && !includeHomeFolderAssets) return;

  const namedFolderCount = (folderPaths?.length ?? 0) + (folderIds?.length ?? 0);
  const totalCount = namedFolderCount + (includeHomeFolderAssets ? 1 : 0);

  if (totalCount === 0) return;

  const displayParts: string[] = [];
  if (includeHomeFolderAssets) displayParts.push('Home');
  if (folderPaths) displayParts.push(...folderPaths);
  const folderIdCount = folderIds?.length ?? 0;
  if (folderIdCount > 0) displayParts.push(`${folderIdCount} ${folderIdCount === 1 ? 'folder' : 'folders'}`);

  const displayLabel =
    totalCount === 1 && displayParts.length > 0 ? truncateFolderPathFromLeft(displayParts[0]) : `${totalCount} folders`;

  const tooltipTitle = displayParts.join(', ');

  return (
    <Tooltip title={tooltipTitle}>
      <StyledChip icon={<FolderIcon />} label={displayLabel} size='small' color='primary' />
    </Tooltip>
  );
};
